import qs from 'qs'
import { useDispatch } from 'react-redux'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { Api } from 'util/services/api'
import { PageableResponse } from 'util/types'
import { StorageItemRefType } from 'util/services/upload'
import { clearAlert, createAlert } from 'util/modules/Alert/redux/actions'
import { GetStorageListPropsSchemaType } from '../schema/storage.items-filter.schema'

export const getBucketInfo = () => {
  return useQuery<GetStorageBucketInfoOutput>(
    ['bucket-info'],
    async () => {
      const { data } = await Api.get<GetStorageBucketInfoOutput>('/storage/info')
      return data
    },
    {
      enabled: true,
      refetchInterval: 5_000,
      refetchOnWindowFocus: true
    }
  )
}

export const getBucketItems = (receivedParams: GetStorageListPropsSchemaType) => {
  const params = JSON.parse(JSON.stringify(receivedParams)) as GetStorageListPropsSchemaType
  return useQuery<PageableResponse<GetStorageListOutput>>(
    ['bucket-items', params],
    async () => {
      if (params.filter?.date) {
        params.filter.date.start = params.filter.date.start?.split('/').reverse().join('-') || undefined
        params.filter.date.end = params.filter.date.end?.split('/').reverse().join('-') || undefined
      }

      const queryString = qs.stringify(params, {
        arrayFormat: 'brackets',
        encode: false
      })
      const { data } = await Api.get<PageableResponse<GetStorageListOutput>>(`/storage?${queryString}`)
      return data
    },
    {
      enabled: true,
      refetchOnWindowFocus: true,
      initialData: { items: [], count: 0, total: 0, page: 1 }
    }
  )
}

export type GetStorageBucketInfoOutput = {
  quota: number,
  used: number,
  files: number
  percentage: number
}

export type GetStorageListOutput = {
  id: string,
  folder: string,
  originalFileName: string,
  url: string,
  size: number,
  refType: StorageItemRefType,
  date: string
}

export const deleteStorageItems = () => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()

  return useMutation(
    async (form: { ids: string[ ]}) => Api.post('/storage/item', form),
    {
      onSuccess: async ({ statusCode, message = 'Item(s) removido(s)' }) => {
        await queryClient.invalidateQueries(['bucket-items'])
        createAlert({ message, code: statusCode })(dispatch)
      },
      onError: (error: Error) => {
        createAlert({ message: error.message || 'Ocorreu um erro ao remover', code: 500 })(dispatch)
      },
      onSettled: () => clearAlert(3_000)(dispatch)
    }
  )
}
